import './styles.css'

import { memo, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { MENTORS_PER_PAGE, useAllMentors } from '../api/apiHooks'
import { Filters } from '../components/filters'
import { MentorCardAdmin } from '../components/MentorCardAdmin'
import NoSearchResults from '../components/NoSearchResults'
import { PageTitle } from '../components/pageTitle'
import { Pagination } from '../components/Pagination'

const typeCompanionMap: Record<string, string> = {
  all: 'ALL',
  Synthetic: 'WITHOUT_DIGITAL_TWIN',
  'Digital Twin': 'WITH_DIGITAL_TWIN',
}

const AdminPage: React.FC = memo(() => {
  const [filteredCount, setFilteredCount] = useState(-1)
  const [searchParams] = useSearchParams()
  const { data, isLoading, isFetching } = useAllMentors({
    pageNumber: searchParams.get('p')
      ? !isNaN(Number(searchParams.get('p')))
        ? Number(searchParams.get('p'))
        : 0
      : 0,
    filters: {
      search: searchParams.get('s')?.trim() || '',
      gender: searchParams.get('gender') || '',
      industry: searchParams.get('industry') || '',
      jobTitle: searchParams.get('jobTitle') || '',
      department: searchParams.get('department') || '',
      race: searchParams.get('race') || '',
      company: searchParams.get('company') || '',
      search_mode: typeCompanionMap[searchParams.get('search_mode') || 'all'],
    },
    sortBy: searchParams.get('sortBy') || '',
    order: searchParams.get('order') || '',
    pageSize: MENTORS_PER_PAGE,
  })

  useEffect(() => {
    if (data) {
      setFilteredCount(data?.filteredCount)
    }
  }, [data])

  return (
    <>
      {isFetching && (
        <div className="w-screen h-screen flex items-center justify-center fixed top-0 left-0 z-[10] bg-black opacity-50" />
      )}
      <div className="tc-mv-main-wrapper pb-8">
        <div className="tc-mv-main-container">
          <div className="text-white tc-mv-card-wrapper">
            <PageTitle mentorsCount={filteredCount} />
            <div className="mt-2">
              <Filters />
            </div>
            {!!data?.items.length && (
              <div className="flex justify-end mt-4">
                <Pagination
                  totalItems={filteredCount}
                  itemsPerPage={MENTORS_PER_PAGE}
                />
              </div>
            )}
            {!isLoading && !data?.items.length ? (
              <NoSearchResults />
            ) : (
              <div className="mt-4 tc-mv-card-container tc-mv-card-container-home">
                {data?.items.map(mentor => (
                  <MentorCardAdmin key={mentor.mentorId} profile={mentor} />
                ))}
              </div>
            )}
            {!!data?.items.length && (
              <div className="flex justify-end mt-4">
                <Pagination
                  totalItems={filteredCount}
                  itemsPerPage={MENTORS_PER_PAGE}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
})

export { AdminPage }
